/**
 * configurationactions.js
 * Created by calhosh on 8/27/2020.
 */
import * as types from '../actiontypes';

export function getConfigurations(url, resource) {
	return {
		type: types.GET_CONFIGURATIONS,
		meta: {
			api: {
				url: url,
				method: 'GET',
				data: {resource: resource}
			}
		}
	};
}
